import { useState } from "react";

export function useFilterState() {
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [workType, setWorkType] = useState<string[]>([]);
  const [actType, setActType] = useState<string[]>([]);
  const [signer, setSigner] = useState<string[]>([]);
  const [statuses, setStatuses] = useState<string[]>([]);

  const [actAction, setActAction] = useState<string[]>([]);
  const [actNumber, setActNumber] = useState<string[]>([]);
  const [actDate, setActDate] = useState<string[]>([]);
  const [workName, setWorkName] = useState<string[]>([]);
  const [workKind, setWorkKind] = useState<string[]>([]);
  const [notes, setNotes] = useState<string[]>([]);
  const [closing, setClosing] = useState<string[]>([]);
  const [author, setAuthor] = useState<string[]>([]);
  const [inspector, setInspector] = useState<string[]>([]);
  const [section, setSection] = useState<string[]>([]);
  const [construction, setConstruction] = useState<string[]>([]);
  const [contract, setContract] = useState<string[]>([]);
  const [ks2, setKs2] = useState<string[]>([]);

  return {
    basic: {
      dateStart, setDateStart,
      dateEnd, setDateEnd,
      workType, setWorkType,
      actType, setActType,
      signer, setSigner,
      statuses, setStatuses,
    },
    extra: {
      actAction, setActAction,
      actNumber, setActNumber,
      actDate, setActDate,
      workName, setWorkName,
      workKind, setWorkKind,
      notes, setNotes,
      closing, setClosing,
      author, setAuthor,
      inspector, setInspector,
      section, setSection,
      construction, setConstruction,
      contract, setContract,
      ks2, setKs2,
    },
  };
}

export type FilterState = ReturnType<typeof useFilterState>;
